import { render, staticRenderFns } from "./Voice.vue?vue&type=template&id=a8197f10&scoped=true&"
import script from "./Voice.vue?vue&type=script&lang=js&"
export * from "./Voice.vue?vue&type=script&lang=js&"
import style0 from "./Voice.vue?vue&type=style&index=0&id=a8197f10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8197f10",
  null
  
)

export default component.exports